import React, { useCallback, useEffect } from "react";
import { Box } from "@mui/material";
import { useIsProjectLocked } from "../utils/lockUtils";
import { closeNewComment } from "../redux/slices/ui";
import { useDispatch, useSelector } from "react-redux";
import { updateProjectState } from "../redux/slices/project";
import CommentThread from "./CommentThread";

const ProjectCommentTab = () => {
    const dispatch = useDispatch();
    const showNewCommentArea = useSelector((state) => state.ui.newComment);
    const project = useSelector((state) => state.project.currentProject);
    const { comments, commentsEnabled, _id: projectId, completedDate } = project;
    const isLocked = useIsProjectLocked(project);
    const isComplete = !!completedDate;

    const handleChanged = useCallback((nextComments) => {
        dispatch(updateProjectState({ project: { comments: nextComments } }));
    }, [dispatch]);

    const handleCloseNewCommentArea = useCallback(() => {
        dispatch(closeNewComment());
    }, [dispatch]);

    useEffect(() => () => dispatch(closeNewComment()), [projectId, dispatch]);

    if (!comments) {
        return <Box>Loading comments...</Box>;
    }

    return (
        <CommentThread
            parentType="project"
            parentId={projectId}
            comments={comments}
            onChanged={handleChanged}
            isLocked={isLocked}
            readOnly={isComplete}
            composerDisabled={!commentsEnabled}
            composerOpen={showNewCommentArea}
            onComposerClose={handleCloseNewCommentArea}
        />
    );
};

export default ProjectCommentTab;
